import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccCpsMax = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.CPS_MAX',
  });
  return result;
};
